import styled from 'styled-components';
import { rgba } from 'polished';
import { COLOR_GREEN, COLOR_LIME_GREEN } from '../../assets/styles/colors';

export default styled.div`
  padding: 60px 0;
  .modal-loading-wrap {
    display: flex;
    justify-content: center;
  }

  .success-icon-wrap {
    margin: 0 auto 20px auto;
    height: 80px;
    width: 80px;
    min-width: 80px;
    border-radius: 40px;
    background: ${rgba(COLOR_LIME_GREEN, 0.2)};
    display: flex;
    justify-content: center;
    svg {
      max-width: 40px;
      margin-top: -2px;
      g {
        stroke: ${COLOR_GREEN};
        stroke-opacity: 1;
        stroke-width: 5;
      }
    }
  }

  .success-message-wrap {
    padding: 10px 0;
    text-align: center;
    button {
      margin-left: 5px;
    }
  }

  .top-text-wrap {
    display: flex;
    flex-direction: column;
    justify-content: center;
    text-align: center;
    align-items: center;
    h2 {
      max-width: 100%;
    }
  }
`;
